import { PageSpinnerContainer, PageSpinnerOverlay } from './StyledUndefinedContractsElements';
import SpinnerIcon from '../../common/SpinnerIcon';
import React from 'react';

const SpinnerOverlayBox = ({ loading }: { loading: boolean }) => {
    return (
        <PageSpinnerOverlay showPageSpinner={loading}>
            <PageSpinnerContainer>
                <SpinnerIcon />
            </PageSpinnerContainer>
        </PageSpinnerOverlay>
    );
};

export default SpinnerOverlayBox;
